import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
//slices
import { userSelector } from 'slices/user';
import { companySelector } from 'slices/company';


const useAssignedLibrary = () => {
  const { slug } = useSelector(companySelector);
  const { isLogged, assigned_library } = useSelector(userSelector);
  const [assignedLibrary, setAssignedLibrary] = useState(slug);

  useEffect(() => {
    if (isLogged && assigned_library?.slug  && assigned_library?.slug !== null) {
      setAssignedLibrary(assigned_library?.slug);
    } else {
      setAssignedLibrary(slug); 
    }
  }, [isLogged, assigned_library, slug]);

  return { assignedLibrary };
};

export default useAssignedLibrary;
